import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Compass from './Compass';
import CompassEditor from './CompassEditor';
import './CompassView.css';

export default function CompassView() {
  return (
    <div className="compass-view" style={{ background: '#F7F9FC', minHeight: '100vh', width: '100%'}} >
      <Routes>
        <Route index element={<Navigate to="saved-notes" replace />} />
        <Route path="saved-notes" element={<Compass />} />
        <Route path="saved-notes/editor" element={<CompassEditor />} />
        <Route path="editor" element={<CompassEditor />} />
      </Routes>
    </div>
  );
} 